<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Edit Gift
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-autocomplete
                ref="gift Category"
                outlined
                v-model="form.gift_category_id"
                :items="giftCategoryItems"
                label="Gift Category"
                prepend-inner-icon="mdi-arrow-expand-all"
                clearable
                :error-messages="errors.gift_category_id"
              ></v-autocomplete>
            </v-col>
            <!-- <v-col sm="4">
              <v-autocomplete
                ref="store"
                outlined
                v-model="form.store_id"
                :items="storeItems"
                label="Store"
                prepend-inner-icon="mdi-arrow-expand-all"
                clearable
                :error-messages="errors.store_id"
              ></v-autocomplete>
            </v-col> -->
            <v-col sm="4">
              <v-text-field
                v-model="form.name"
                outlined
                label="Name"
                prepend-inner-icon="mdi-card-text-outline"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.quantity"
                outlined
                label="Quantity"
                prepend-inner-icon="mdi-card-text-outline"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-switch
                class="mt-0 ml-5"
                v-model="form.is_active"
                inset
                :label="`Is Active: ${form.is_active ? 'YES' : 'NO'}`"
              ></v-switch>
            </v-col>
            <v-col sm="4">
              <v-switch
                class="mt-0 ml-5"
                v-model="form.is_redemption"
                inset
                :label="`Is Redeem: ${form.is_redemption ? 'YES' : 'NO'}`"
              ></v-switch>
            </v-col>
          </v-row>
          <v-divider class="my-5"> </v-divider>
          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Update Gift
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";

export default {
  name: "GiftEditPage",
  data() {
    return {
      form: {
        is_active: false,
        is_redemption: false,
      },
      giftCategoryItems: [],
      storeItems: [],
      isLoading: false,
    };
  },
  mounted() {
    this.getData();
    this.getMasters();
  },
  methods: {
    //get data for masters
    async getMasters() {
      await axios
        .get(`gifts/masters`)
        .then((masters) => {
          masters = masters.data;
          //Gift Categories
          masters.gift_categories.forEach((giftCategory) => {
            this.giftCategoryItems.push({
              id: giftCategory.id,
              text: giftCategory.name,
              value: giftCategory.id,
            });
          });
          //Store
          masters.stores.forEach((store) => {
            this.storeItems.push({
              id: store.id,
              text: store.name,
              value: store.id,
            });
          });
        })
        .catch(function (error) {
          console.log(error);
          // redirect to Home Page
          window.location.href = "/auth/login";
        });
    },
    //get data (text filed)
    async getData() {
      this.isLoading = true;
      let encryptedId = this.$route.params.giftId;
      axios
        .get(`/gifts/${encryptedId}`)
        .then((response) => {
          this.form = response.data.data;
          this.old_json = response.data.data;
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
      this.isLoading = false;
    },
    async save() {
      try {
        this.isLoading = true;
        console.log(this.form);
        await axios.patch(`/gifts/${this.$route.params.giftId}`, this.form);
        await this.saveUserTimestamp(this.old_json, this.form);
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
      }
    },
    async saveUserTimestamp() {
      try {
        let form = {
          from_path: `/gift/${this.form.id}`,
          from_name: "GiftEditPage",
          user_id: this.user.id,
          old_json: JSON.stringify(this.old_json),
          new_json: JSON.stringify(this.form),
        };
        await axios.post(`/user_timestamps`, form);
        this.$router.push("/gifts");
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
